<template>
  <div class="bgView">
    <div class="registerBox">
      <header class="registerBoxHeader">
        <div class="registerBoxTitle">注册用户</div>
        <img class="closeBtn" :src="closeImg"  @click="cancelBtnClicked"/>
      </header>
      <div class="registerBoxBody">
        <div class="registerItem">
          <img class="registerItemImg" :src="userImg"/>
          <input class="registerItemInput"  v-model="username" placeholder="请输入用户名(3-20位)" 
          maxlength="20"/>
        </div>
        <div class="registerItem">
          <img class="registerItemImg" :src="passwordImg"/>
          <input class="registerItemInput" :type="isShowPassword?'text':'password'" 
          v-model="password" placeholder="请输入密码(3-20位)"
          maxlength="20" />
          <img class="passwordVisibleImg" :src="isShowPassword?eyeSeeImg:eyeHideImg"
          @click="reversePasswordVisibility"/>
        </div>
        <div class="registerBtn" @click="register">注册</div>
      </div>
    </div>
   
  </div>
  
</template>

<script>
import axios from 'axios'

export default {
  name: 'Register',
  data () {
    return {
      username:'',
      password:'',
      isShowPassword:false,
      closeImg: require("../assets/images/close.png"),
      userImg: require("../assets/images/user.png"),
      passwordImg: require("../assets/images/password.png"),
      eyeHideImg:require("../assets/images/eye_hide.png"),
      eyeSeeImg:require("../assets/images/eye_see.png"),
    }
  },
  mounted() {
   
  },
  methods: {
    cancelBtnClicked() {
      this.$emit("onRegisterClose")
    },
    reversePasswordVisibility() {
      this.isShowPassword = !this.isShowPassword;
    },
    register() {
      console.log("username = ",this.username);
      console.log("password = ",this.password);
      if(this.username.length == 0) {
        $alertBox.alert({
          message:"请输入用户名"
        })
        return;
      }
      if(this.password.length == 0) {
        $alertBox.alert({
          message:"请输入密码"
        })
        return;
      }
      if(this.username.length < 3) {
        $alertBox.alert({
          message:"用户名至少三位"
        })
        return;
      }
      if(this.password.length < 3) {
        $alertBox.alert({
          message:"密码至少三位"
        })
        return;
      }
      let url = baseIp + 'user/register'
      let json = {
        username:this.username,
        password:this.password,
      }
      let param = this.$jsEncrypt(JSON.stringify(json))
      let config = {
        headers:{
          'Content-Type':'application/json; charset=utf-8',
        
          "Access-Control-Allow-Origin":'*'
        }
        
      };
     
      console.log(url);

      axios.post( url,param,config)
      .then((res)=>{
        console.log(res);
        console.log(res.data); 
        if (res.data.code ==200) {
          console.log("emit onRegisterClose");
            this.$message({
              type: 'success',
              message: res.data.message
            })
            this.$emit("onRegisterClose");

            // $alertBox.alert({

            //   message:res.data.message,
            //   showCancel:true,
            //   cancelText:"稍后再说",
            //   confirmText:"立即登录",
            //   onConfirm() {
            //     console.log("this = ",this);
            //     console.log("this.$emit onRegisterSuccess ");
            //      this.$emit("onRegisterSuccess");
            //   },
            //   onCancel() {
            //     this.$emit("receiveClose");
            //   }
            // })
          
        }
        else {
            // alert(res.data.message);
            // $confirm.alert({
            //   content: res.data.result
            // });
            $alertBox.alert({

              message:res.data.message
            })
        }
       

      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.bgView {
  width:100%;
  height: 100%;
  top:60px;
  left:0;
  position: absolute;
  background: #000000a0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.registerBox {
  width:320px;
  height: auto;
  background: white;
   border-radius: 8px;
}

.registerBoxHeader {
  width:100%;
  height: 40px;
  position: relative;
  border-bottom: 1px solid black;
  
}
.registerBoxTitle {
  width:100%;
  height:100%;
  position:absolute;
  color: #222226;
  font-size:16px;
  line-height: 40px;
}

.closeBtn {
  width: 20px;
  height: 20px;
  right:20px;
  top:10px;
  position: absolute;
   cursor: pointer;
}

.registerBoxBody {
  width:calc(100% - 20px);
  height: auto;
  padding:10px;

}

.registerItem {
  height: 40px;
  display: flex;
  align-items: center;
  border: 1px solid #cccccc;
  border-radius: 4px;
  margin-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  position: relative;
}
.registerItemImg {
  width:20px;
  height: 20px;
  position:relative;
}
.registerItemInput {
  height:30px;
  padding-left: 10px;
}
.passwordVisibleImg {
  width: 20px;
  height: 20px;
  right:20px;
  position: absolute;
}
.registerBtn {
  
  width: 100%;
  height: 40px;
  color: #fff;
  line-height: 40px;
  background-color: #007fff;
  border-radius: 2px;
  outline: none;
  box-sizing: border-box;
  cursor: pointer;
  margin-top: 20px;
}

.registerBoxFooter {
   width:100%;
  height: 40px;
  position: relative;
  border-top: 1px solid black;
}
.cancelBtn {
  width:100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Register.vue